<input type="file" #file style="display: none" [accept]="acceptExtensions == null ? undefined : _Arrays.itemsToString(acceptExtensions, ',')" (change)="_onFilesAdded()"/>
